import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "./LegalPage";

export default function DeliveryPolicy() {
  const { t } = useTranslation();
  const sections = t("legal.delivery.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t("common.legal.deliveryPolicy")}
      updated={t("legal.delivery.updated")}
      sections={sections}
    />
  );
}
